import { CategoryAirPlaySecurityProfileConfiguration } from '@era/settings-sdk';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

export type CategoryAirplaySecurityProfilePresetConfigurationState =
  EntityState<CategoryAirPlaySecurityProfileConfiguration>;

export function selectId(configuration: CategoryAirPlaySecurityProfileConfiguration): string {
  return `${configuration.categoryType}-${configuration.categoryId}-${configuration.airPlaySecurityProfilePresetId}`;
}

export const adapter: EntityAdapter<CategoryAirPlaySecurityProfileConfiguration> =
  createEntityAdapter<CategoryAirPlaySecurityProfileConfiguration>({
    selectId,
  });

export const initialState: CategoryAirplaySecurityProfilePresetConfigurationState = adapter.getInitialState();
